import { Stack, Typography } from '@mui/material';

import Image from '../../components/image';
import {
  StyledContent,
  StyledRoot,
  StyledSection,
  StyledSectionBg,
} from './styles';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
  illustration?: string;
  title?: string;
};

const LoginLayout = ({ children, illustration, title }: Props) => {
  return (
    <StyledRoot>
      <StyledSection>
        <Typography
          sx={{ maxWidth: 480, mb: 10, textAlign: 'center' }}
          variant="h3"
        >
          {title || 'Hej, välkommen tillbaka'}
        </Typography>

        <Image
          alt="auth"
          disabledEffect
          src={
            illustration || '/assets/illustrations/illustration_dashboard.png'
          }
          sx={{ maxWidth: 720 }}
          visibleByDefault
        />

        <StyledSectionBg />
      </StyledSection>

      <StyledContent>
        <Stack sx={{ width: 1 }}> {children} </Stack>
      </StyledContent>
    </StyledRoot>
  );
};

export default LoginLayout;
